import {I18N_SELECTABLE_OPTIONS_KEY, I18N_VALUE_CODE_KEY, I18N_VALUE_HELP_MESSAGE_KEY} from 'lf-at-theme';
import {catalogs, ktI18nFn} from '../../../shared';

const {allCountriesCodeOnlyOptions} = catalogs.countries.i18n_pt_PT;

/**
 * Import form i18n object for the pt-PT locale.
 */

export const importFormI18nPtPT: Record<string, any> = {
  '/import-form': {
    label: 'Regime de Importação - Registo',
    identificationOfBusiness: 'Numero de Identificação Fiscal',
    taxReferenceNumber: 'Numero de Identificação (se não houver número de identificação IVA)',
    validations: {
      BUSINESS_AND_ISSUING_COUNTRIES_NOT_EQUAL: '[País do número fiscal](lf://./identificationOfBusiness/issuingCountry)  tem de ser igual ao [País de sede](lf://./countryOfBusiness) ou à [Região/Território](lf://./cobRegion).',
      COB_REGION_SHOULD_BE_USED: ktI18nFn(({parentA2, regionA2}) => `Para usar o [País do número fiscal](lf://./identificationOfBusiness/issuingCountry) escolhido, o [País Sede](lf://./countryOfBusiness) e [Região/Território](lf://./cobRegion) devem ser mudados respetivamente para ${parentA2} e ${regionA2}.`),
      ISSUER_COUNTRY_NOT_EQUAL_PARENT: '[País do número fiscal](lf://./identificationOfBusiness/issuingCountry) tem de ser igual ao [País Sede](lf://./countryOfBusiness).',
      ISSUING_COUNTRY_NOT_EQUAL_REGION: '[País do número fiscal](lf://./identificationOfBusiness/issuingCountry) tem de ser igual à [Região/Território de Sede](lf://./cobRegion).',
      ISSUING_COUNTRY_MS_IS_EU_COUNTRY: 'Só pode indicar um Estado-Membro como [Emissor de Número de Identificação Fiscal](lf://./identificationOfBusiness/issuingCountry) quando os números fiscais associados a essa região têm obrigatoriamente esse Estado-Membro como emissor. Deve indicar o mesmo valor que em [Região](lf://./cobRegion).',
      ISSUER_COUNTRY_XIXU_NOT_ALLOWED: '[País do número fiscal](lf://./identificationOfBusiness/issuingCountry) não pode ser "XI - Irlanda do Norte" nem "XU - Reino Unido sem Irlanda do Norte". Deve ser usado "GB - Reino Unido".',
    }
  },

  '/?/meetsConditions': {
    label: 'Confirmo que reúno as condições para me registar neste regime.'
  },

  '/?/currVatId': {
    netpVat: 'Número de identificação IVA',
    netpHelp: 'Número de identificação individual IVA atribuído pelo Estado-Membro de identificação nos termos do artigo 369.o-Q, n.o 1 ou 3, da Diretiva 2006/112/CE',
    intermediaryVat: 'Número de identificação do intermediário',
    intermediaryHelp: 'Se o sujeito passivo for representado por um intermediário, o número de identificação individual desse intermediário, atribuído nos termos do artigo 369.o-Q, n.o 2, da Diretiva 2006/112/CE',
  },
  '/?/currVatId/vatIdNum': {
    legend: 'Preenchido pelo sistema após aprovação'
  },

  '/?/intermediaryVat': {
    [I18N_VALUE_CODE_KEY]: '1a',
    legend: 'Preenchido pelo sistema'
  },

  '/?/changePlaceOfBusiness': {
    label: 'Sujeito passivo mudou de país de sede ou de estabelecimento',
  },

  '/?/identificationOfBusiness': {
    label: 'Numero de Identificação Fiscal',
  },
  '/?/identificationOfBusiness/issuingCountry': {
    label: 'País',
    [I18N_SELECTABLE_OPTIONS_KEY]: allCountriesCodeOnlyOptions,
    [I18N_VALUE_CODE_KEY]: '2a'
  },
  '/?/identificationOfBusiness/vatIdNum': {
    label: 'Número IVA',
    validations: {
      NIF_WITH_NO_CADASTRO: 'NIF sem dados de cadastro',
      NIF_WITH_NO_VAT_ACTIVITY: 'NIF sem actividade IVA aberta',
      NIF_WITH_NO_FIXED_ESTAB: 'NIF sem estabelecimento estável',
    }
  },
  '/?/identificationOfBusiness/taxRefNum': {
    label: 'Número de Identificação',
    [I18N_VALUE_CODE_KEY]: '2'
  },

  '/?/countryOfBusiness': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'País em que o sujeito passivo tem a sua sede'
  },

  '/?/fixedEstablishments/?/taxIdentif/vatIdNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Número(s) de identificação individual IVA ou, se não existir(em), número(s) de identificação fiscal atribuído(s) pelo(s) Estado-Membro(s) em que o sujeito passivo dispõe de estabelecimento(s) estável(is) que não seja(m) o Estado-Membro de identificação.'
  },

  '/?/fixedEstablishments/?/taxIdentif/taxRefNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Número de identificação fiscal atribuído pelo Estado-Membro'
  },


  '/?/prevOrCurrOssVatId': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Número(s) de identificação individual IVA atribuído(s) pelo Estado-Membro de identificação nos termos dos artigos 362.o, 369.o-D ou 369.o-Q da Diretiva 2006/112/CE, caso o sujeito passivo tenha utilizado anteriormente ou esteja atualmente a utilizar um desses regimes'
  },

  // Consent / Change of MSID
  '/?/registration': {
    label: 'Confirmações',
  },

  '/?/relevantDates/registrationReqDate': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Data do pedido de registo no regime apresentado pelo sujeito passivo ou pelo intermediário que aja por sua conta'
  },

  '/?/relevantDates/forecastStartDate': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Data da decisão de registo tomada pelo Estado-Membro de identificação'

  },
};
